import type { SVGProps } from 'react';

const SvgLineLink = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height={17}
    viewBox='0 0 16 17'
    width={16}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M14.167 8.38a3.177 3.177 0 0 0-3.166-3.167H9.994a.5.5 0 0 1 0-1h1.007a4.177 4.177 0 0 1 4.166 4.167 4.177 4.177 0 0 1-4.166 4.166H9.994a.5.5 0 0 1 0-1h1.007a3.177 3.177 0 0 0 3.166-3.166M.834 8.38a4.174 4.174 0 0 1 4.167-4.167h1l.1.01a.5.5 0 0 1 0 .98l-.1.01h-1A3.174 3.174 0 0 0 1.834 8.38a3.177 3.177 0 0 0 3.167 3.166h1l.1.011a.5.5 0 0 1 0 .98l-.1.01h-1A4.177 4.177 0 0 1 .834 8.38'
      fill='#3889FF'
    />
    <path d='m10.667 7.88.102.01a.5.5 0 0 1 0 .98l-.102.01H5.334a.5.5 0 0 1 0-1z' fill='#3889FF' />
  </svg>
);
export default SvgLineLink;
